import { render } from "./partener-form.vue?vue&type=template&id=1fc2669a&scoped=true&ts=true"
import script from "./partener-form.vue?vue&type=script&lang=ts"
export * from "./partener-form.vue?vue&type=script&lang=ts"

import "./partener-form.vue?vue&type=style&index=0&id=1fc2669a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc2669a"]])

export default __exports__